import { DropDown, DropDownOption } from '@aibees/shared/components';
import { AdvanceTableFilterValue } from '@aibees/shared/features';
import { memo, useState } from 'react';
import type { TableFilterSelectProps } from './types';
import { useDropdownOptions } from './use-dropdown-options';

function TableFilterSelect<T>({
  filters,
  setFilter,
  defaultValue,
  options,
  icon,
  name,
  sx,
}: TableFilterSelectProps<T>) {
  const [value, setValue] = useState<T | undefined>(defaultValue);

  const handleChange = (newValue: DropDownOption['value']) => {
    setValue(newValue as T);
    setFilter(name as string, newValue as AdvanceTableFilterValue);
  };

  const dropdownOptions = useDropdownOptions(options);

  return (
    <DropDown
      key={name}
      variant="outlined"
      size="small"
      value={value}
      onChange={handleChange}
      sx={sx}
      options={dropdownOptions}
      withCheckmark
    />
  );
}

TableFilterSelect.displayName = 'TableFilterSelect';

const MemoizedTableFilterSelect = memo(TableFilterSelect) as <T>(
  props: TableFilterSelectProps<T>
) => JSX.Element;

export default MemoizedTableFilterSelect;
